<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_session.add_title')">
    <template #content>
      <v-container fluid class="add-session" v-if="event">
        <v-form v-model="isFormValid"
                ref="addSessionForm">
          <v-text-field readonly
                        :label="$t('admin_hkiarace.event')"
                        :value="$sanitizeHtml(event.name)"></v-text-field>
          <v-text-field readonly
                        :label="$t('admin_event.signup_mode')"
                        :value="signupModeLabel"></v-text-field>
          <v-text-field outlined
                        :label="$t('admin_session.name_en')"
                        v-model="session.name_en"
                        :rules="requiredRules"></v-text-field>
          <v-text-field outlined
                        :label="$t('admin_session.name_zh')"
                        v-model="session.name_zh"
                        :rules="requiredRules"></v-text-field>
          <v-text-field outlined
                        :label="$t('admin_event.order_no')"
                        v-model="session.order_no"
                        type="number"
                        min="0"
                        step="1"
                        :rules="requiredRules"></v-text-field>
          <v-input :rules="requiredRules"
                   v-model="session.start">
            <v-container fluid class="flex-column pa-0">
              <legend class="v-label theme--light">{{ $t('admin_session.start') }}</legend>
              <DateTimePickerInput v-model="session.start"
                                   hide-details></DateTimePickerInput>
            </v-container>
          </v-input>
          <v-input :rules="sessionEndRules"
                   v-model="session.end">
            <v-container fluid class="flex-column pa-0">
              <legend class="v-label theme--light">{{ $t('admin_session.end') }}</legend>
              <DateTimePickerInput v-model="session.end"
                                   hide-details></DateTimePickerInput>
            </v-container>
          </v-input>
          <v-input :rules="[
                      value => (unlimitedQuota || !!value) || $t('register.required_fields'),
                    ]"
                   v-model="session.quota"
                   v-if="event.signup_mode === 2">
            <v-container fluid class="px-0">
              <v-row>
                <v-col class="pb-0">
                  <v-text-field outlined
                                :label="$t('admin_session.quota')"
                                type="number"
                                v-model="session.quota"
                                hide-details
                                :disabled="unlimitedQuota">
                  </v-text-field>
                </v-col>
                <v-col cols="2" class="pb-0">
                  <v-checkbox :label="$t('unlimited')"
                              v-model="unlimitedQuota"></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-input>
        </v-form>
      </v-container>
    </template>

    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.addSessionForm.validate() && save()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>

<script>
import {computed, ref, watch} from "@vue/composition-api";
import BGModal from "@/components/BGModal";
import DateTimePickerInput from "@/components/DateTimePickerInput";

export default {
  name: 'AddSessionModal',
  components: {DateTimePickerInput, BGModal},
  props: {
    eventId: String,
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getEvent();
          session.value = {};
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    // Form
    const isFormValid = ref(false);
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const event = ref(null);
    const getEvent = function () {
      root.$callAPI('hkiarace/admin/event/', {id: props.eventId}, function (response) {
        event.value = response.body.event;
      })
    };
    const signupModeLabel = computed(() => {
      if (event.value) {
        return {
          "-1": root.$t('event_signup_mode.disabled'),
          "1": root.$t('event_signup_mode.single_session'),
          "2": root.$t('event_signup_mode.multi_session'),
          "3": root.$t('event_signup_mode.multi_series'),
        }[event.value.signup_mode];
      }
    })

    const session = ref({});
    const sessionEndRules = ref([
      ...requiredRules.value,
      value => (!session.value.start || value > session.value.start) || 'Please enter valid session start / end',
    ])
    const unlimitedQuota = ref(false);

    const save = function () {
      let params = {
        ...session.value,
        event_id: props.eventId,
        quota: (event.value.signup_mode === 2 && !unlimitedQuota.value) ? session.value.quota : -1,
      }

      root.$callAPI('event/session/create/', params, (response) => {
        emit('finish', response.body.session);
      });
    }

    return {
      dialogShown,
      cancel,

      isFormValid,
      requiredRules,

      event,
      signupModeLabel,

      session,
      sessionEndRules,
      unlimitedQuota,

      save,
    }
  },
}
</script>
